import { Clock } from 'lucide-react';
import TimezoneSelector from '../TimezoneSelector';

export function PreferencesTab() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Developer Preferences
        </h2>
      </div>

      {/* Timezone Preferences - no platform selection in developer app */}
      <div className="space-y-4">
        <div className="flex items-center gap-3 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
          <Clock className="h-5 w-5 text-gray-500 dark:text-gray-400" />
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
              Timezone Settings
            </label>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              All timestamps will be displayed in your selected timezone
            </p>
          </div>
        </div>

        <div className="pl-0">
          <TimezoneSelector className="max-w-md" showLabel={false} />
        </div>
      </div>
    </div>
  );
}
